<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" lazy persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Qualificar</span>
          <v-spacer />
          <span class="subheading grey--text"
            >Assinado: {{ this.user.signedcontract_by }} | Status:
            {{ user.status }}</span
          >
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 v-if="isDocValidation">
                <v-text-field
                  v-model="user.name"
                  name="name"
                  label="Nome"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 v-if="isDocValidation">
                <v-text-field
                  id="ID_document"
                  v-model="user.ID_document"
                  label="Documento"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 v-if="isDocValidation">
                <v-text-field
                  id="cpf"
                  v-model="user.cpf"
                  label="CPF/CNPJ"
                  return-masked-value
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-btn
                  class="mx-0 font-weight-light"
                  color="tertiary"
                  :loading="loading"
                  :disabled="loading"
                  @click="showDocumentModal(user)"
                >
                  Ver documentos
                </v-btn>
              </v-flex>
              <v-flex xs12 sm8 v-if="isDocValidation">
                <v-autocomplete
                  v-model="photo_status"
                  :items="invalid_photo_status"
                  item-text="text"
                  item-value="value"
                  label="Validação"
                  @change="
                    photo_status == 'valid'
                      ? (new_status = 'ATIVO')
                      : (new_status = 'AGUARDANDO_DOCUMENTO')
                  "
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-divider v-if="isDocValidation" />
              <v-flex xs12>
                <v-radio-group
                  v-model="new_status"
                  label="Novo status"
                  name="status"
                  required
                  :disabled="
                    photo_status || user.status === 'VALIDAR_DOCUMENTO'
                  "
                  :rules="[(v) => !!v || 'Por favor, informe o Status!']"
                  :hint="'Informe o Status'"
                >
                  <v-radio label="Ativo" value="ATIVO"></v-radio>
                  <v-radio label="Qualificar" value="QUALIFICAR"></v-radio>
                  <v-radio
                    label="Desqualificado"
                    value="DESQUALIFICAR"
                  ></v-radio>
                  <v-radio
                    label="Aguardando Conta"
                    value="AGUARDANDO_CONTA"
                  ></v-radio>
                  <v-radio
                    label="Multiplas Contas"
                    value="MULTIPLAS_CONTAS"
                  ></v-radio>
                  <v-radio
                    label="Aguardando N. de Instalação"
                    value="AGUARDANDO_NRO_INSTALACAO"
                  ></v-radio>
                  <v-radio label="Não é o Titular" value="NOT_HOLDER"></v-radio>

                  <v-radio
                    label="Não tem interesse"
                    value="NAO_INTERESSADO"
                  ></v-radio>
                  <v-radio
                    v-if="isDocValidation"
                    label="Aguardando Documento"
                    value="AGUARDANDO_DOCUMENTO"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 v-if="new_status == 'DESQUALIFICAR'">
                <v-autocomplete
                  :items="reason_desqualify_items"
                  label="Motivo da Desqualificação"
                  v-model.lazy="reason_desqualify"
                  :rules="[
                    (v) =>
                      !!v ||
                      'Por favor, selecione o motivo da desqualificação!',
                  ]"
                  :hint="'Selecione o motivo da desqualificação'"
                  required
                ></v-autocomplete>
                <!-- <v-textarea
                  outline
                  name="reason_desqualify"
                  label="Motivo da Desqualificação"
                  v-model="reason_desqualify"
                ></v-textarea> -->
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.prevent="dialog = false">
            Fechar sem salvar
          </v-btn>
          <v-btn
            color="blue darken-1"
            :disabled="!new_status || (isDocValidation && !photo_status)"
            :loading="loading"
            @click="saveQualificationChange()"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DocumentModal ref="documentModal" />
    <v-snackbar
      :color="snack.color"
      :bottom="snack.bottom"
      :top="snack.top"
      :left="snack.left"
      :right="snack.right"
      v-model="snack.snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snack.snackMessage }}</div>
      <v-icon size="16" @click="snack.snackbar = false">
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </v-layout>
</template>
<script>
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
import DocumentModal from "../../components/sales/kanban/DocumentModal.vue";
import firestore from "../../firebase/firestore";
import { sendEmail } from "../../services/sendEmailNovo";
import { sendPushNotification } from "../../services/sendPushNotification";
import { sendWhatsApp } from "../../services/sendWhatsApp";

export default {
  props: ["user"],
  components: { DocumentModal },
  computed: {
    ...mapGetters(["loggedUser"]),
    isDocValidation() {
      return (
        (this.user.signedcontract_by === "mobile_app" &&
          this.new_status === "ATIVO") ||
        this.user.status === "VALIDAR_DOCUMENTO" ||
        this.photo_status
      );
    },
  },
  data: function () {
    return {
      dialog: false,
      active: false,
      loading: false,
      photo_status: undefined,
      new_status: "",
      invalid_photo_status: [
        { text: "✅ Tudo certo!", value: "valid" },
        {
          text: "❗ Foto do documento ilegível",
          value: "unreadable_doc_photo",
        },
        {
          text: "❗ Selfie não corresponde ao documento",
          value: "invalid_selfie",
        },
        { text: "❗ Documento não é do titular", value: "doc_not_holder" },
      ],
      reason_desqualify: "",
      reason_desqualify_items: [
        "Débitos na Cemig",
        "Encerrado na Cemig",
        "Consumo Baixo",
        "Economia Baixa",
        "Tarifa Baixa",
        "Tarifa Rural",
        "Tarifa Social",
        "Tarifa Empresarial ou Industrial",
        "Unidade ou Cliente já existente",
        "Possui energia injetada",
      ],
      snack: {
        color: null,
        top: true,
        bottom: false,
        left: false,
        right: false,
        snackMessage: "",
        snackbar: false,
      },
    };
  },
  mounted() {
    eventBus.$on("qualification", async (value) => {
      this.dialog = value;
    });
  },
  methods: {
    showDocumentModal(customer) {
      this.$refs.documentModal.showDocumentModal(customer);
    },
    async saveQualificationChange() {
      this.loading = true;
      try {
        let obj = {
          status: this.new_status,
          last_agent_id: this.loggedUser.id || null,
          last_agent_name: this.loggedUser.name || null,
          last_agent_email: this.loggedUser.email || null,
          qualification_agent: this.loggedUser.email || null,
          qualification_at: new Date(),
        };
        if (this.photo_status) obj["photo_status"] = this.photo_status;
        if (this.reason_desqualify)
          obj["reason_desqualify"] = this.reason_desqualify;
        await firestore
          .collection("users")
          .doc(this.user.customer_id)
          .update(obj);
        this.user.status = this.new_status;
        this.show_snack("Status alterado com sucesso!", "green", "top");
        this.dialog = false;
        await this.sendCommunication();
      } catch (e) {
        console.error(e);
        this.show_snack(
          "Erro ao salvar novo status: " + e.message,
          "error",
          "top",
        );
      }
      this.loading = false;
    },
    async sendCommunication() {
      let emailMsg = this.buildEmailMsg();
      if (emailMsg) {
        sendEmail(emailMsg).then(
          () => console.log("Email enviado!"),
          (error) => console.error(error),
        );
      }
      let wppMsg = this.buildWppMsg();
      if (wppMsg) {
        sendWhatsApp(wppMsg).then(
          () => console.log("WhatsApp enviado!"),
          (error) => console.error(error),
        );
      }
      if (
        this.user.id &&
        this.photo_status &&
        this.new_status === "AGUARDANDO_DOCUMENTO"
      ) {
        sendPushNotification({
          user_id: this.user.id,
          photo_status: this.photo_status,
          type: "aguardandoDocumento",
        }).then(
          () => console.log("Push Notification enviado!"),
          (error) => console.error(error),
        );
      }
    },
    buildEmailMsg() {
      try {
        let templateId;
        let dynamicTemplateData;
        if (this.new_status === "AGUARDANDO_DOCUMENTO") {
          if (this.photo_status == "unreadable_doc_photo") {
            templateId =
              process.env.VUE_APP_SENDGRID_TEMPLATE_AGUARDANDO_DOCUMENTO;
            dynamicTemplateData = {
              name: this.user.name,
              docs: "as fotos dos documentos estão ilegíveis",
              url: "https://api.whatsapp.com/send?phone=553597560252&text=Ol%C3%A1%20%3AD",
            };
          } else if (this.photo_status == "invalid_selfie") {
            templateId =
              process.env.VUE_APP_SENDGRID_TEMPLATE_AGUARDANDO_DOCUMENTO;
            dynamicTemplateData = {
              name: this.user.name,
              docs: "a selfie não corresponde ao documento",
              url: "https://api.whatsapp.com/send?phone=553597560252&text=Ol%C3%A1%20%3AD",
            };
          } else if (this.photo_status == "doc_not_holder") {
            templateId =
              process.env.VUE_APP_SENDGRID_TEMPLATE_AGUARDANDO_DOCUMENTO;
            dynamicTemplateData = {
              name: this.user.name,
              docs: "a foto do documento não é do titular",
              url: "https://api.whatsapp.com/send?phone=553597560252&text=Ol%C3%A1%20%3AD",
            };
          }
        } else if (this.new_status == "NOT_HOLDER") {
          templateId = process.env.VUE_APP_SENDGRID_TEMPLATE_NOT_HOLDER;
          dynamicTemplateData = {
            name: this.user.name,
          };
        } else if (this.new_status == "AGUARDANDO_NRO_INSTALACAO") {
          templateId =
            process.env.VUE_APP_SENDGRID_TEMPLATE_AGUARDANDO_NRO_INSTALACAO;
          dynamicTemplateData = {
            name: this.user.name,
          };
        } else if (this.new_status == "MULTIPLAS_CONTAS") {
          templateId = process.env.VUE_APP_SENDGRID_TEMPLATE_MULTIPLAS_CONTAS;
          dynamicTemplateData = {
            name: this.user.name,
          };
        } else if (this.new_status == "AGUARDANDO_CONTA") {
          templateId = process.env.VUE_APP_SENDGRID_TEMPLATE_AGUARDANDO_CONTA;
          dynamicTemplateData = {
            name: this.user.name,
          };
        } else if (this.new_status == "DESQUALIFICAR") {
          templateId = process.env.VUE_APP_SENDGRID_TEMPLATE_DESQUALIFICAR;
          dynamicTemplateData = {
            name: this.user.name,
          };
        }
        if (templateId && dynamicTemplateData) {
          return {
            msg: {
              to: {
                email: this.user.email,
                name: this.user.name,
              },
              from: {
                email: "atendimento@juntosenergia.com.br",
                name: "Enercred :: Energia Limpa e Barata",
              },
              templateId: templateId,
              dynamicTemplateData: dynamicTemplateData,
            },
          };
        }
      } catch (e) {
        console.error(e);
      }
    },
    buildWppMsg() {
      try {
        let name = this.user.name;
        let trouble;
        let docs;
        if (this.new_status == "NOT_HOLDER") {
          trouble =
            "identificamos que você não é o titular da conta de energia";
          docs =
            "(1) conta(s) de energia ou número(s) de instalação da(s) unidade(s) consumidora(s) que deseja receber o desconto. (2) documento do titular da conta de energia com número do CPF. (3) documento do responsável pela inscrição na Enercred";
        } else if (this.new_status == "AGUARDANDO_NRO_INSTALACAO") {
          trouble = "não encontramos cadastro para o CPF informado";
          docs =
            "(1) conta(s) de energia ou número(s) de instalação da(s) unidade(s) consumidora(s) que deseja receber o desconto. (2) documento do titular da conta de energia. (3) documento do responsável pela inscrição na Enercred";
        } else if (this.new_status == "MULTIPLAS_CONTAS") {
          trouble = "você possui mais de uma unidade consumidora";
          docs =
            "conta(s) de energia ou número(s) de instalação da(s) unidade(s) consumidora(s) que deseja receber o desconto.";
        } else if (this.new_status == "AGUARDANDO_CONTA") {
          trouble = "sua conta não foi encontrada";
          docs = "conta de energia atualizada";
        }
        if (name && trouble && docs) {
          return {
            has_to_query_params: false,
            medium: "whatsapp",
            params: {
              name: name,
              trouble: trouble,
              docs: docs,
            },
            rule_id: "qualificacao_super",
            user_info: {
              user_id: this.user.id,
            },
          };
        }
      } catch (e) {
        console.error(e);
      }
    },
    show_snack(message, color, ...args) {
      this.snack.top = false;
      this.snack.bottom = false;
      this.snack.left = false;
      this.snack.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snack.color = color;
      this.snack.snackMessage = message;
      this.snack.snackbar = true;
    },
    formatPhone(phone) {
      let ddi = "55";
      let _phone = phone.replace(/\D/g, "");
      let initials = _phone.substring(0, 2);
      if (initials === ddi) return _phone;
      if (_phone.length >= 10 || _phone.length >= 11) {
        _phone = ddi.toString() + _phone.toString();
      } else {
        console.error("Telefone sem DDD: ", _phone);
      }
      return _phone;
    },
  },
};
</script>
